export default __webpack_public_path__ + "static/media/board.bd883406.svg";